import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { reportingYear } from "../../../constants";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";
import ShareOfConsumptionCostsVsUsersBySectorChart from "./ShareOfConsumptionCostsVsUsersBySectorChart";

const ShareOfConsumptionCostsVsUsersBySectorChartWidget = props => {
  const [methodId, setMethodId] = useState();

  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="share_of_consumption_costs_vs_users_by_sector_chart"
      reference="Figure 4.7"
      title={`Share of Consumption Costs versus Users by Sector, ${reportingYear}`}
      subtitle="Comparison by GNI Group"
      contentWidth={650}
      filters={[
        <MethodChooser
          id="figure-4-7"
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: "theme4.shareOfConsumptionCostsVsUsersBySectorChart",
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      chartRef={ref}
      chartSettings={{
        method: methodId ? props.database.methods[methodId] : "All"
      }}
      downloadAbsoluteValues={true}
    >
      <ShareOfConsumptionCostsVsUsersBySectorChart
        ref={ref}
        data={props.data}
        indicator={6}
      />
    </DataViewerFrame>
  );
};

ShareOfConsumptionCostsVsUsersBySectorChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ShareOfConsumptionCostsVsUsersBySectorChartWidget;
